import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const ADMIN_DASHBOARD = 'ADMIN_DASHBOARD';
export const ADMIN_DASHBOARD_SUCCESS = 'ADMIN_DASHBOARD_SUCCESS';
export const ADMIN_DASHBOARD_FAILURE = 'ADMIN_DASHBOARD_FAILURE';

// Action Creators
export const getAdminDashboard = () => ({
  type: ADMIN_DASHBOARD,
});

export const getAdminDashboardSuccess = (users) => ({
  type: ADMIN_DASHBOARD_SUCCESS,
  payload: users,
});

export const getAdminDashboardFailure = (error) => ({
  type: ADMIN_DASHBOARD_FAILURE,
  payload: error,
});

// Thunk Function
export const adminDashboard = (
  external,
  pageCount,
  countryValue,
  stateValue,
  cityValue,
  titleValue
) => {
  return async (dispatch) => {
    dispatch(getAdminDashboard());
    try {
      let adminDashboardUrl = url?.adminDashboard;

      const params = [];

      // Check if only titleValue is defined
      if (
        titleValue !== undefined &&
        !countryValue &&
        !stateValue &&
        !cityValue
      ) {
        params.push(`title_id=${titleValue}`);
      } else {
        // Add params only if defined
        if (pageCount !== undefined) {
          params.push(`page=${pageCount}`);
        }
        if (countryValue !== undefined) {
          params.push(`country_id=${countryValue}`);
        }
        if (stateValue !== undefined) {
          params.push(`state_id=${stateValue}`);
        }
        if (cityValue !== undefined) {
          params.push(`city_id=${cityValue}`);
        }
        if (titleValue !== undefined) {
          params.push(`title_id=${titleValue}`);
        }
      }

      // Add params if any exist
      if (params.length > 0) {
        adminDashboardUrl += `?${params.join('&')}`;
      }

      const response = await getMethodWithToken(adminDashboardUrl);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getAdminDashboardSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getAdminDashboardFailure(error?.message));
    }
  };
};
